import { getLocale } from './locale-selector/locale-selector.js';

export const ENDPOINTS = {
  BUILD_QR: '/q/build-qr'
};

export const TIME_OUT = 500;

const SUPPORTED_LOCALES = ['en', 'es'];
export const LOCALES_NAME = {
  en: 'English',
  es: 'Español'
};

export function locale() {
  return getLocale({ SUPPORTED_LOCALES });
}
